import type { FC } from 'react';
import { IntlProvider } from 'react-intl';

import { useConfiguration } from '../../contexts/configurationContext';

export const I18nContainer: FC = ({ children }) => {
  const locale = document.documentElement.lang || 'en';
  const { translatedMessages } = useConfiguration();

  return (
    <IntlProvider
      locale={locale}
      messages={translatedMessages}
    >
      {children}
    </IntlProvider>
  );
};
